import * as ReactGA from "react-ga";

export const initGA = (id) => {
    ReactGA.initialize(id);
    ReactGA.pageview(window.location.pathname + window.location.search);
};